<!-- Bouton Retour au parcours appelant -->
<dsd-link-action variant="return" class="dsd-mb-md">
  <a [href]="urlRetourParcoursExterne">{{ libelleParcoursExterne.value | translate }}</a>
</dsd-link-action>
